var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 25,
    viewBox: "0 0 18 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#007AFF",
    strokeWidth: 1.548
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M9.474 0L9.474 14.118",
    transform: "translate(-180 -598) translate(180 599)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.823 0L9.474 3.328",
    transform: "translate(-180 -598) translate(180 599) matrix(-1 0 0 1 22.297 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.474 0L6.124 3.328",
    transform: "translate(-180 -598) translate(180 599)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.167 6.833v16.452H.833V6.833h16.334z",
    transform: "translate(-180 -598) translate(180 599) rotate(90 9 15.059)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShare);
export default __webpack_public_path__ + "static/media/ic-share.7872147d0e467bc039a1e27b413796ed.svg";
export { ForwardRef as ReactComponent };